import React from "react";
import Main from "../components/MainPage/Main";
import Service from "../components/Service/Service";
import AboutUs from "../Pages/AboutUs/AboutUs";
import Appointment from "../Pages/Appointment/Appointment";
import Contact from "../Pages/Contact/Contact";

const Home = () => {
  return (
    <>
      <Main />
      <Service />
      <AboutUs />
      <Appointment />
      <Contact />
    </>
  );
};

export default Home;
